import { methodGet, methodDelete, methodPost, methodPut, methodPatch } from './methods';
import { API_INFO } from '../constants';

const config = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

export async function getAllSliders(payload) {
    const url = API_INFO + 'products/slider-elements/';
    return methodGet(url, payload);
}

export async function createSlider(payload) {
  const url = API_INFO + 'products/slider-elements/';
  return methodPost(url, payload, config);
 
}

export async function deleteSlider(id) {
  const url = API_INFO + `products/slider-elements/${id}/`;
  return methodDelete(url, {});
}

export const editSlider = async (id, payload,) => {
  const url = API_INFO + `products/slider-elements/${id}/`;
  return methodPatch(url, payload, config);
};